import React from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import { Box } from '@mui/material';

// List of routes that should not have the standard layout
const fullPageRoutes = ['/', '/register'];

const Layout = ({ children }) => {
  const location = useLocation();
  const isFullPageRoute = fullPageRoutes.includes(location.pathname);
  
  // Add debug log
  console.log('Layout rendering. Path:', location.pathname, 'isFullPageRoute:', isFullPageRoute);
  
  if (isFullPageRoute) {
    // Return just the children for full-page routes (landing page and registration)
    console.log('Using full page layout (no header/footer)');
    return (
      <div style={{ background: '#f0f0f0', position: 'relative' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, padding: '5px', background: 'rgba(0,0,0,0.2)', color: 'white', fontSize: '10px' }}>
          Full Page Mode
        </div>
        {children}
      </div>
    );
  }
  
  // Standard layout with navbar, main content, and footer
  console.log('Using standard layout (with header/footer)');
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navigation />
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;